import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import StripoTemplateType from '@/data/models/domain/stripo/StripoTemplateType'

@OrmModel(modelNames.STRIPO_TEMPLATE_FEATURE)
export default class StripoTemplateFeature extends StripoTemplateType {}
